<template>
    <div class="pluswrap">
        <slot class="plus"></slot>
    </div>
</template>

<script>
    export default {
        name: "SpinnerWrapper"
    }
</script>

<style scoped>
    .pluswrap {
        position: fixed;
        width: 100%;
        height:100%;
        display: flex;
        align-items: center;
        top: 0;
        background: rgba(0, 0, 0, 0.2);
        z-index: 99999;
    }

    .plus {
        display: flex;
        margin: 0 auto;
    }
</style>